import * as React from "react";
import { cn } from "@volca/ui/lib/utils";

/**
 * A record's attributes as label and value rows: the label muted on the
 * left, the value on the right of a shared column line.
 */
export const AttributeList = ({
  className,
  ...props
}: React.ComponentProps<"dl">) => (
  <dl
    data-slot="attribute-list"
    className={cn(
      "grid grid-cols-[minmax(7rem,auto)_minmax(0,1fr)] gap-x-4 text-sm",
      className,
    )}
    {...props}
  />
);

/** One attribute. An icon may lead the label; an empty value reads as a dash. */
export const AttributeItem = ({
  label,
  icon,
  children,
  className,
}: {
  label: React.ReactNode;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}) => (
  <div
    className={cn(
      "col-span-2 grid grid-cols-subgrid items-center py-1.5",
      className,
    )}
  >
    <dt className="flex min-w-0 items-center gap-2 text-subtle [&_svg]:size-4 [&_svg]:shrink-0">
      {icon}
      <span className="truncate">{label}</span>
    </dt>
    <dd className="min-w-0 truncate text-ink tabular-nums">
      {children ?? <span className="text-subtlest">—</span>}
    </dd>
  </div>
);
